import { render, staticRenderFns } from "./ProjekterfassungtableKunde.vue?vue&type=template&id=ad4f2410&"
import script from "./ProjekterfassungtableKunde.vue?vue&type=script&lang=js&"
export * from "./ProjekterfassungtableKunde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports